import { ShirtspaceResponse } from "@services/shirtspace.types";
import React, { useEffect, useState } from "react";
import ProductBulkPricing from "~/components/ProductBulkPricing";
import ProductQuantitySelector from "~/components/ProductQuantitySelector";
import {
  Product,
  ProductAvailability as TProductAvailability,
} from "~/entities/product/types";
import { SelectedVariant } from "~/entities/variant/types";
import { fetchProductAvailability } from "~/services/resources/productAvailability.client";

type ContainerProps = {
  isSignedIn: boolean;
  selectedVariant: SelectedVariant;
  product: Product;
};

const ProductAvailability: React.FC<ContainerProps> = ({
  isSignedIn,
  selectedVariant,
  product,
}) => {
  const [productAvailabilityFromResource, setProductAvailabilityFromResource] =
    useState<Promise<ShirtspaceResponse<TProductAvailability>> | undefined>(
      undefined,
    );

  useEffect(() => {
    setProductAvailabilityFromResource(
      fetchProductAvailability(product.styleCode, selectedVariant.color),
    );
  }, [selectedVariant]);

  return (
    <div className="flex w-full flex-col items-center gap-[4rem] px-3.5">
      <ProductBulkPricing
        isSignedIn={isSignedIn}
        productAvailability={productAvailabilityFromResource}
        selectedVariant={selectedVariant}
      />
      <ProductQuantitySelector
        product={product}
        productAvailability={productAvailabilityFromResource}
      />
    </div>
  );
};

export default ProductAvailability;
